import { forwardRef } from 'react';
import MuiTab, { TabProps as MuiTabProps } from '@mui/material/Tab';
import Typography from '../Typography';
import type { HeadlinesType } from '../Tabs';

export interface TabProps extends MuiTabProps {
  color?: 'internal';
  textVariant?: HeadlinesType;
}

const Tab = forwardRef<HTMLDivElement, TabProps>(({ label, textVariant, ...props }, ref) => {
  const labelVal = textVariant ? (
    <Typography variant={textVariant} component="span">
      {label}
    </Typography>
  ) : (
    label
  );

  return <MuiTab ref={ref} label={labelVal} {...props} />;
});

Tab.displayName = 'Tab';

export default Tab;
